export default __webpack_public_path__ + "static/media/github.296ddf5d.svg";